import script from "./PCPartWarehousesPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartWarehousesPopup.vue?vue&type=script&setup=true&lang=js"

import "./PCPartWarehousesPopup.vue?vue&type=style&index=0&id=6d4160d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4160d4"]])

export default __exports__